/**
 * Shared PLUGIN-DISCOVERY (ADR-0114) — the one mechanism every auto-discovered registry uses: from a Vite
 * EAGER `import.meta.glob` of modules, pick each module's single export matching a shape `predicate` (the
 * registry-member object). Keeps `./plugins` (hero render/theme) and `./content-plugins` (collectibles) DRY —
 * a new registry is a glob + a predicate, not a re-implementation of the glob → find-export → filter dance.
 * Web-only (the globs run through Vite); the glob LITERAL stays at each call site (Vite resolves it at build).
 */
export function pickModuleExports<T>(
  modules: Record<string, Record<string, unknown>>,
  predicate: (value: unknown) => value is T,
): readonly T[] {
  return Object.values(modules)
    .map((mod) => Object.values(mod).find(predicate))
    .filter((v): v is T => v !== undefined);
}

/** Build a keyed registry from discovered members — `keyOf` derives each member's lookup key (its id/kind). */
export function keyBy<T>(members: readonly T[], keyOf: (member: T) => string): Record<string, T> {
  return Object.fromEntries(members.map((m) => [keyOf(m), m]));
}
